import { useSearchParams } from "react-router-dom";
import { AskPanel } from "../AskPanel";
import s from "../network.module.css";

/** /ask, or /ask?contactId=<id> when opened from a person page ("Ask about {name}"). */
export function AskPage() {
  const [params] = useSearchParams();
  const contactId = params.get("contactId") ?? undefined;
  return (
    <div className={s.page}>
      <div className={s.pageBody} style={{ display: "flex", flexDirection: "column", maxWidth: 820, width: "100%", margin: "0 auto" }}>
        <AskPanel key={contactId ?? "none"} contactId={contactId} />
      </div>
    </div>
  );
}
